import React from 'react';
import { DonutLegendChart } from '@/components/ui/DonutLegendChart';

export function ProjectPersonnelStats() {
  const statsData = [
    { name: 'Nội bộ', value: 18, color: '#3b82f6' },
    { name: 'Nhà thầu', value: 16, color: '#10b981' },
    { name: 'Tư vấn / GS', value: 2, color: '#f59e0b' },
  ];

  return (
    <DonutLegendChart
      title="Cơ cấu nhân sự"
      centerValue={36}
      centerLabel="Tổng nhân sự"
      data={statsData}
      total={36}
    />
  );
}
